import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { TBlogModuleTable } from '../../blog/blog.types';

import './BlogArticleModuleTable.scss';

type Props = {
  module: TBlogModuleTable;
  mobile?: boolean;
};

export const BlogArticleModuleTable: React.FC<Props> = ({
  module: { columns },
  mobile,
}) => {
  const maxRows = Math.max(
    ...columns.map(column => column.item.entries.length)
  );

  const rows: undefined[] = Array.from({ length: maxRows });

  return (
    <div>
      <table
        className={clsx('BlogArticleModuleTable', {
          'BlogArticleModuleTable--mobile': mobile,
          'BlogArticleModuleTable--desktop': !mobile,
        })}
      >
        <thead className='BlogArticleModuleTable__header'>
          <tr>
            {columns.map(column => (
              <td
                className={clsx('BlogArticleModuleTable__header-entry', {
                  'BlogArticleModuleTable__header-entry--mobile': mobile,
                  'BlogArticleModuleTable__header-entry--desktop': !mobile,
                })}
                key={column.item.moduleId}
              >
                {column.item.columnHeader}
              </td>
            ))}
          </tr>
        </thead>

        <tbody className='BlogArticleModuleTable__body'>
          {rows.map((_, rowIndex) => (
            <tr className='BlogArticleModuleTable__data-row' key={rowIndex}>
              {columns.map(column => (
                <td
                  className={clsx('BlogArticleModuleTable__data-cell', {
                    'BlogArticleModuleTable__data-cell--mobile': mobile,
                    'BlogArticleModuleTable__data-cell--desktop': !mobile,
                  })}
                  key={`data-for-${column.item.moduleId}`}
                >
                  <Typography variant='body'>
                    {column.item.entries[rowIndex]?.item.value || '-'}
                  </Typography>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
